import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Router } from '@angular/router';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [],
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  private router = inject(Router);


  navigateToProjects(): void {
    this.router.navigate(['/projects']);
  }
}
